import { stringToBig, bigToBigInt } from '@/utils/bigUtils.ts';

export { leverageFromHundredths } from '@/utils/leverageUtils.ts';

// Leverage is stored in hundredths (2x leverage = 200)
const LEVERAGE_DECIMALS = 2;
const DEFAULT_LEVERAGE = 1;

export const leverageForOnChain = (leverage?: number | string): bigint => {
  const leverageBig = stringToBig((leverage || DEFAULT_LEVERAGE).toString());
  return bigToBigInt(leverageBig, LEVERAGE_DECIMALS);
};

export const leverageForApi = (leverage?: number | string): number => {
  const leverageBig = stringToBig((leverage || DEFAULT_LEVERAGE).toString());
  return leverageBig.times(100).toNumber();
};
